import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../../../../shared/common';
import {
  LoadingIndicatorModule
} from '../../../../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../../../../shared/layout/components/breadcrumb/breadcrumb.module';
import {ConfirmDialogComponent} from '../../../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {AgmJsMarkerClustererModule} from '@agm/js-marker-clusterer';
import {AgmCoreModule} from '@agm/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {LocationsComponent} from './locations.component';
import {LocationDialogComponent} from './location-dialog.component';
import {LocationsService} from './locations.service';
import {MatExpansionModule} from '@angular/material/expansion';
import {FloatingLabelModule} from '@progress/kendo-angular-label';

@NgModule({
  declarations: [
    LocationsComponent,
    LocationDialogComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    InputsModule,
    FloatingLabelModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    MatExpansionModule,
    AgmCoreModule,
    AgmJsMarkerClustererModule,
    FlexLayoutModule
  ],
  providers: [
    LocationsService
  ],
  entryComponents: [
    ConfirmDialogComponent,
    LocationDialogComponent
  ],
})
export class LocationsModule {
}
